import Util from '@/lib/util'
export default [
    {
        title:Util.L('Order'),
        key:'orderNo',
        width:70
    },
    {
        title:Util.L('DocumentType'),
        key:'documentTypeName',
    },
    {
        title:Util.L('Name'),
        key:'name'
    },
    {
        title:Util.L('Url'),
        key:'fullUrl'
    },
    {
        title: Util.L('Action'),
        width:100,
        fixed:'right',
        slot: 'action',
        align: 'center'
    }
]